module.exports = __webpack_public_path__ + "static/product-design-0797f8572702a523c544f3d7d910803b.jpg";